import ReactFilestack from "filestack-react";
import PropTypes from "prop-types";
import { FILESTACK_API_KEY, filestackOptions } from "common/helpers/filestack";
import { FileUpload } from "../FileUpload";

export const FilestackButton = ({
  onSuccess,
  onError,
  onFileRemove,
  document = {},
  fieldName,
  uploadLabelText = "Choose file...",
  disableFileCta = false,
  style,
  options,
}) => (
  <ReactFilestack
    fluid
    apikey={FILESTACK_API_KEY}
    actionOptions={filestackOptions({
      fromSources: ["local_file_system", "url", "googledrive", "dropbox"],
      ...options,
    })}
    onSuccess={onSuccess}
    onError={onError}
    customRender={({ onPick }) => (
      <FileUpload
        {...document}
        fieldName={fieldName}
        uploadLabelText={uploadLabelText}
        onPick={onPick}
        onFileRemove={onFileRemove}
        disableFileCta={disableFileCta}
        style={style}
      />
    )}
  />
);

FilestackButton.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  onFileRemove: PropTypes.func.isRequired,
  document: PropTypes.shape({
    resourceUrl: PropTypes.string,
    resourceFilename: PropTypes.string,
    documentType: PropTypes.string,
    contentType: PropTypes.string,
  }),
  fieldName: PropTypes.string.isRequired,
  uploadLabelText: PropTypes.string,
  disableFileCta: PropTypes.bool,
  style: PropTypes.object,
  options: PropTypes.object,
};
